import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { Pressable, View } from 'react-native';

/**
 * A titled row of chips, each switched on or off. A `section` row opens a
 * filter (难度); a `group` row is one part of a section (练习能力 · 理解客户).
 */
export const ToggleChips = memo(
  <T extends string | number>({
    title,
    level = 'section',
    options,
    selected,
    onToggle,
  }: {
    title: string;
    level?: 'section' | 'group';
    options: { value: T; label: string }[];
    selected: readonly T[];
    onToggle: (value: T) => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const section = level === 'section';
    return (
      <View style={{ marginTop: rpx(section ? 14 : 8) }}>
        <Typography.Text
          size={rpx(section ? 14 : 12)}
          bold={section || undefined}
          color={section ? aiColors.foreground : aiColors.mutedForeground}
        >
          {title}
        </Typography.Text>
        <View
          style={{
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: rpx(6),
            marginTop: rpx(6),
          }}
        >
          {options.map(option => {
            const on = selected.includes(option.value);
            return (
              <Pressable
                key={String(option.value)}
                onPress={() => onToggle(option.value)}
                accessibilityRole="checkbox"
                accessibilityState={{ checked: on }}
                style={{
                  borderRadius: rpx(999),
                  borderWidth: 1,
                  borderColor: on ? aiColors.primary : aiColors.border,
                  backgroundColor: on ? aiColors.primary : aiColors.card,
                  paddingHorizontal: rpx(11),
                  paddingVertical: rpx(4),
                }}
              >
                <Typography.Text
                  size={rpx(12)}
                  medium={on || undefined}
                  color={on ? aiColors.primaryForeground : aiColors.foreground}
                >
                  {option.label}
                </Typography.Text>
              </Pressable>
            );
          })}
        </View>
      </View>
    );
  },
);
